import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

const unitKeys = {
  all: ['units'],
  lists: () => [...unitKeys.all, 'list'],
};

export const useUnits = () => {
  return useQuery({
    queryKey: unitKeys.lists(),
    queryFn: async () => {
      const response = await apiClient.get('units');
      return response.data;
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });
};
